import endpoints from 'config/endpoints';
import {AWSSUPPORT_TYPES_ARR, AWSSUPPORT_SECTIONS} from 'config/constants/awsSupport';

import {invalidateAwsSupport} from 'modules/store/awsSupport';
import {getApi} from 'modules/api';
import {addNotification, NOTIFICATION_TYPE} from 'modules/notifications';

import {DEFAULT_ARRAY} from 'util/constants';

export const invalidateAwsTickets = () => dispatch => {
    dispatch(invalidateAwsSupport());
};
export const attachFile = (newAttachments, account) => dispatch => {
    const newAttachmentFiles = newAttachments.map(item => item.file);

    const url = endpoints.awsSupport.attachments.endpoint.replace(':account', account);

    return getApi()
        .postFile(url, newAttachmentFiles)
        .then(res => {
            const fileNames = newAttachments.map(a => a.name).join(', ');

            dispatch(addNotification(
                'title.aws_support',
                {idFormat: 'form.aws_support.attachments.success', fileNames, filesCount: newAttachments.length},
                NOTIFICATION_TYPE.SUCCESS
            ));

            return res;
        })
        .catch(e => {
            dispatch(addNotification(
                'title.aws_support',
                e.message,
                NOTIFICATION_TYPE.ERROR
            ));

            throw e;
        });
};
export const detachFile = (hash, account) => () => {
    const url = endpoints.awsSupport.attachments.instanceEndpoint.replace(':account', account);

    return getApi()
        .delete_(url.replace(':id', hash));
};

const CHANGE_SELECTED_ACCOUNT = 'CHANGE_SELECTED_ACCOUNT';

export const changeSelectedAccount = (section, account) => ({
    type: CHANGE_SELECTED_ACCOUNT,
    section, account
});
const _changeSelectedAccount = (state, {section, account}) => ({
    ...state,
    [section]: {
        ...state[section],
        selectedAccount: account
    }
});

const INIT_COMMENTS_AWSTICKET = 'INIT_COMMENTS_AWSTICKET';

export const initCommentsAwsTicket = () => ({
    type: INIT_COMMENTS_AWSTICKET
});
const _initCommentsAwsTicket = state => ({
    ...state,
    [AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_COMMENTS]: {
        ...state[AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_COMMENTS],
        comments: DEFAULT_ARRAY
    }
});
const SET_COMMENTS_AWSTICKET = 'SET_COMMENTS_AWSTICKET';

export const setCommentsAwsTicket = comments => ({
    type: SET_COMMENTS_AWSTICKET,
    comments
});
const _setCommentsAwsTicket = (state, {comments}) => ({
    ...state,
    [AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_COMMENTS]: {
        ...state[AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_COMMENTS],
        comments: state[AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_COMMENTS].comments.concat(comments)
    }
});

const CHANGE_SELECTED_SERVICE = 'CHANGE_SELECTED_SERVICE';

export const changeSelectedService = (section, service) => ({
    type: CHANGE_SELECTED_SERVICE,
    section, service
});
const _changeSelectedService = (state, {section, service}) => ({
    ...state,
    [AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_FORM]: {
        ...state[AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_FORM],
        selectedServices: {
            ...state.selectedServices,
            [section]: service
        }
    }
});

const _getInitialState = () => ({
    [AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_FORM]: {
        selectedAccount:  null,
        selectedServices: AWSSUPPORT_TYPES_ARR.reduce((ret, item) => ({
            ...ret,
            [item]: null
        }), {})
    },
    [AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_LIST]: {
        selectedAccount: null
    },
    [AWSSUPPORT_SECTIONS.AWSSUPPORT_SECTION_COMMENTS]: {
        comments: DEFAULT_ARRAY
    }
});


export const reducer = (state = _getInitialState(), action = {}) => {
    switch (action.type) {
    case CHANGE_SELECTED_SERVICE:
        return _changeSelectedService(state, action);
    case CHANGE_SELECTED_ACCOUNT:
        return _changeSelectedAccount(state, action);
    case SET_COMMENTS_AWSTICKET:
        return _setCommentsAwsTicket(state, action);
    case INIT_COMMENTS_AWSTICKET:
        return _initCommentsAwsTicket(state);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/awsTickets.js